import React, { memo } from "react";
import { glass_options } from "../../../../lib/constant";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBan} from "@fortawesome/pro-solid-svg-icons";

const GlassOptionsRadioGroup = memo(
    ({ type, register, formState: { isDirty }, control }) => {
        return (
            <>
                {glass_options.map(({ name }) => (
                    <div key={name} className="group">
                        <div
                            key={name}
                            className="relative flex flex-col items-center justify-start group-has-[:checked]:bg-[#555454] p-3"
                        >
                            {name === 'none' ? (
                                    <div className='h-20 w-full flex items-center justify-center'>
                                        <FontAwesomeIcon className='w-full h-12 text-gray-600 group-has-[:checked]:text-white' icon={faBan}/>
                                    </div>
                                ) :
                                <div className='flex h-20 items-center justify-center'>
                                    <img
                                        className="size-12"
                                        src={`/assets/glass/${name}.jpg`}
                                        alt={name}
                                    />
                                </div>
                            }
                            <p className="text-gray-600 text-xs group-has-[:checked]:text-white">
                                {name}
                            </p>
                            <input
                                className="absolute inset-0 h-full w-full opacity-0 z-20 cursor-pointer "
                                type="radio"
                                value={name}
                                {...register("glass_option")}
                            />
                        </div>
                    </div>
                ))}
            </>
        );
    },
    (prevProps, nextProps) =>
        prevProps.formState.isDirty === nextProps.formState.isDirty
);

export default GlassOptionsRadioGroup;

